<template>
  <div class="lead">
    <div class="limage">
      <img
        src="../assets/img/cimlapkep-head.png"
        alt="Forbes címlap"
      >
    </div>
    <div class="ltext">
      <img
        class="leadtitle"
        src="../assets/img/lead-HL.png"
        alt="50 leggzadagabb magyar"
      >
      <h1>50 leggzadagabb magyar</h1>
      <h2>2018</h2>
      <p>Öt százalékkal robog a magyar gazdaság – meg is látszik a Forbes milliárdoslistáján, a gazdagok még gazdagabbak lettek. Az adófizetők és a kisbefektetők dollármilliárdossá tették az államkapitalizmus első számú kedvezményezettjét, Mészáros Lőrincet. A Forbes ötödször állítja össze a legvagyonosabb magyarok rangsorát, az eddigi 33 név helyett immár ötvennel.
      </p>
      <div class="social">
        <a
          href="mailto:@?subject=Magyarorsz%C3%A1g%2050%20leggazdagabb%20embere.%20-%20Forbes&body=http%3A%2F%2Fforbes.hu%2Fextra%2F50-leggazdagabb-magyar-2018%2F"
          title="Elküldöm a E-mailben"
        ><img
            class="email"
            src="../assets/img/mail-icon.svg"
            alt="Elküldöm a E-mailben"
          ></a>
        <a
          href="https://www.facebook.com/sharer/sharer.php?u=http%3A//forbes.hu/extra/50-leggazdagabb-magyar-2018/"
          target="_blank"
          title="Megosztom a Facebookon"
        ><img
            class="face"
            src="../assets/img/facebook-icon.svg"
            alt="Megosztom a Facebookon"
          ></a>
        <a
          href="https://twitter.com/home?status=Magyarorsz%C3%A1g%2050%20leggazdagabb%20embere%3A%20http%3A//forbes.hu/extra/50-leggazdagabb-magyar-2018/"
          target="_blank"
          title="Megosztom a Twitteren"
        ><img
            class="twitt"
            src="../assets/img/twitter-icon.svg"
            alt="Megosztom a Twitteren"
          ></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LeadComponent',
  props: {

  },
};
</script>

<style scoped lang="css">
.lead {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-rows: auto;
  background-color: #eebb22;
  padding: 15px 30px;
}
.limage {
  grid-column: 1/2;
  grid-row: 1/2;
  align-self: center;
  text-align: center;
}
.limage img {
  max-width: 100%;
}
.ltext {
  grid-column: 2/3;
  grid-row: 1/2;
  text-align: center;
  color: #fff;
  font-size: 16px;
  display: grid;
  align-items: center;
  justify-items: center;
}
.ltext p {
  margin-block-start: 5px;
  margin-block-end: 5px;
}
h1,
h2 {
  margin: 0px;
  margin-block-start: 10px;
  margin-block-end: 10px;
  display: none;
}
.social .email {
  height: 25px;
  margin: 0 10px;
}
.social .face,
.social .twitt {
  height: 30px;
  margin: 0 10px;
}
.leadtitle {
  max-width: 100%;
}
@media screen and (max-width: 767px) {
  .lead {
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: auto auto;
    padding: 15px 30px;
  }
  .limage {
    grid-column: 1/2;
    grid-row: 1/2;
  }
  .ltext {
    grid-column: 1/2;
    grid-row: 2/3;
  }
  .limage img, .leadtitle  {
    max-width: 380px;
    width: 100%;
  }
}
</style>
